import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiTopic } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ScreenSizeContext } from '@wix/da-shared-react/pkg/Measured/ScreenSizeContext';
import ContentLoader from '../../../ContentLoader';
import TopTopics from '../../../TopTopics';
import BasePageLayout from '../../_partials/BasePageLayout';
import TopicGrid from '../../../TopicGrid';
import s from './TopicListPage.scss';

const DESKTOP_GUTTER = 40;
const MOBILE_GUTTER = 16;
const NETWORKBAR_WIDTH = 72;

export interface Props {
  /* an array of topics considered most popular */
  topTopics: PapiTopic[];
  /* array of all topics */
  allTopics: PapiTopic[];
}

const TopicListPage: React.FC<Props> = ({ topTopics = [], allTopics = [] }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { width: screenWidth } = useContext(ScreenSizeContext);
  const gutterSize = isMobile ? MOBILE_GUTTER : DESKTOP_GUTTER;
  const availableWidth = screenWidth - gutterSize * 2 - NETWORKBAR_WIDTH;

  return (
    <BasePageLayout
      title={t('subnavigation.title.topicList')}
      withNavigation={false}
      contentClassName={s['content']}
    >
      <ContentLoader>
        {!isMobile && (
          <TopTopics
            title={t('topicListPage.topTopics')}
            availableWidth={availableWidth}
            topTopics={topTopics}
            allTopics={allTopics}
            className={s['top-topics']}
          />
        )}
        <TopicGrid
          screenWidth={screenWidth}
          allTopics={allTopics}
          withTitle={!isMobile}
          className={s['topic-grid']}
        />
      </ContentLoader>
    </BasePageLayout>
  );
};
TopicListPage.displayName = 'TopicListPage';
export default TopicListPage;
